/* eslint-disable eqeqeq */
import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import Snackbar from '../../containers/snackbarContainer';
import LoginPage from './loginpage';
import PasswordPage from './passwordPage';
import MultiprofilesPage from './multiprofilePage';
import CantSignInPage from './cantSignin';
import SignInWithOtp from './signinWithOtp';
import AlreadLoggedIn from './alreadyLoggedIn';
import history from '../../utils/history';
import ProductLogo from '../../assets/images/IPP_product_logo.svg';
import { takeToDashboard, isMobile } from '../../utils/common/index';
const breakPoints = {
  xs: 24,
  sm: 12,
  md: 8,
  lg: 7,
  xl: 6,
};
const privacyPolicyUrl = 'https://www.happay.in/privacy.html';
const termOfUseUrl = 'https://www.happay.in/terms.html';

export default class LoginTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.loginInfo = {
      code: '',
      value: '',
      activeTab: 1,
      userId: '',
    };
  }

  componentDidMount() {
    this.props.getCountryCodes({});
    takeToDashboard();
  }

  getCountryCodesArray() {
    const codes = this.props.countryCodes.map(item => {
      const obj = { text: item.country, value: item.country_code };
      return obj;
    });
    return codes;
  }

  render() {
    const {
      countryCodes = [],
      errorString,
      _checkSSO,
      sesisonResendOTP,
      sesisonVerifyOTP,
      tempToken,
    } = this.props;
    const countryCodesArray = countryCodes.length
      ? this.getCountryCodesArray()
      : [];
    return (
      <Switch>
        <Route exact path="/login/passwordpage">
          <PasswordPage
            onCallLoginApi={data => {
              this.props.loginApi(data, this.props.encryptionKey);
            }}
            countryCodes={countryCodesArray}
            loginInfo={this.loginInfo}
            productLogo={ProductLogo}
            privacyPolicyUrl={privacyPolicyUrl}
            termOfUseUrl={termOfUseUrl}
          />
        </Route>
        <Route exact path="/login/multiprofiles">
          <MultiprofilesPage
            onProfileSelect={orgData => {
              this.loginInfo.code = orgData.mobile_extension;
              if (this.loginInfo.activeTab === 1) {
                this.loginInfo.value = orgData.mobile_number;
              } else {
                this.loginInfo.value = orgData.email_id;
              }
              this.loginInfo.userId = orgData.user_id;
              if (orgData.auth_status == 0) {
                history.push('/login/passwordpage');
              }
            }}
            userProfiles={this.props.profiles}
            loginInfo={this.loginInfo}
            productLogo={ProductLogo}
            privacyPolicyUrl={privacyPolicyUrl}
            termOfUseUrl={termOfUseUrl}
          />
        </Route>
        <Route
          exact
          path="/login/cantsignin"
          component={() => (
            <CantSignInPage
              productLogo={ProductLogo}
              privacyPolicyUrl={privacyPolicyUrl}
              termOfUseUrl={termOfUseUrl}
            />
          )}
        />
        <Route exact path="/login/signinwithotp">
          <SignInWithOtp
            {...this.props}
            loginInfo={this.loginInfo}
            productLogo={ProductLogo}
            privacyPolicyUrl={privacyPolicyUrl}
            termOfUseUrl={termOfUseUrl}
            sendOTP={data => {
              this.props.generateOTP(data);
            }}
            OTPSent={this.props.OTPSent}
            onLogin={otpData => {
              this.props.loginApi(otpData, {});
            }}
          />
        </Route>
        <Route exact path="/login/alreadyLoggedIn">
          <AlreadLoggedIn
            str={errorString}
            tempToken={tempToken}
            onSubmit={sesisonVerifyOTP}
            onResend={sesisonResendOTP}
            loginInfo={this.loginInfo}
          />
        </Route>
        <Route exact path="/login">
          <LoginPage
            countryCodes={countryCodesArray}
            onFetchAuthMode={query => {
              const param = {
                user: query.emailID || query.phoneNo,
                mobile_extension: query.code,
              };
              this.props.fetchauthmode(param);
              this.loginInfo.code = query.code;
              this.loginInfo.value = query.emailID || query.phoneNo;
              this.loginInfo.activeTab = query.activeTab;
            }}
            _checkSSO={_checkSSO}
            productLogo={ProductLogo}
            privacyPolicyUrl={privacyPolicyUrl}
            termOfUseUrl={termOfUseUrl}
          />
        </Route>
      </Switch>
    );
  }
}

LoginTab.propTypes = {
  fetchauthmode: PropTypes.func,
  loginApi: PropTypes.func,
  profiles: PropTypes.array,
  getCountryCodes: PropTypes.func,
  countryCodes: PropTypes.array,
  encryptionKey: PropTypes.object,
  generateOTP: PropTypes.func,
  OTPSent: PropTypes.bool,
  _checkSSO: PropTypes.func,
};

LoginTab.defaultProps = {
  OTPSent: false,
  profiles: [],
};
